<template>
  <div id="signup-view">
    <head>
      <meta name="description" content="Sign up for an account with CalMed Hawaii and access our healthcare services. Fill out the registration form with your name, email, phone, date of birth, address, and more">
    </head>
    <b-overlay>
      <section class="bg-light ftco-section">
        <div class="d-flex justify-content-center">
          <img
            src="@/assets/site/images/loader.gif"
            v-if="loader === true"
            class="img-fluid loader-width"
            alt
          />
        </div>
        <div class="container" v-if="!loader">
          <div class="row d-flex justify-content-center">
            <div class="col-md-10">
              <div style="margin-top: 2rem">
                <div class="card-body bg-dark-gray">
                  <h1 class="text-black display-4 my-4">Sign up</h1>
                  <form>
                    <label for="">name</label>
                    <div class="row">
                      <div class="col-md-6">
                        <div class="form-group">
                          <input
                            type="text"
                            class="form-control"
                            v-model="first_name"
                            placeholder="First Name*"
                          />
                          <span class="text-danger" v-if="errors.first_name">{{
                            this.errors.first_name[0]
                          }}</span>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <input
                            type="text"
                            class="form-control"
                            v-model="last_name"
                            placeholder="Last Name*"
                          />
                          <span class="text-danger" v-if="errors.last_name">{{
                            this.errors.last_name[0]
                          }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="">e-mail</label>
                          <input
                            type="email"
                            class="form-control"
                            v-model="email"
                            placeholder="Email Address*"
                          />
                          <span class="text-danger" v-if="errors.email">{{
                            this.errors.email[0]
                          }}</span>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="">Phone</label>
                          <input
                            type="text"
                            class="form-control"
                            v-model="phone"
                            placeholder="Phone. No*"
                          />
                          <span class="text-danger" v-if="errors.phone">{{
                            this.errors.phone[0]
                          }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="row ">
                      <div class="col-md-4">
                        <div class="form-group">
                          <label for=""
                            >Date of birth
                            <i
                              class="fa fa-calendar pl-2"
                              aria-hidden="true"
                            ></i
                          ></label>
                          <!-- <b-form-datepicker hide-header  placeholder="Date of Birth*" class="form-control noBorder dateHeight" v-model="date_of_birth" ></b-form-datepicker> -->
                          <!-- <input type="date"  class="form-control" placeholder="Date of birth*"  v-model="date_of_birth"> -->
                          <!-- <datepicker
                            class="form-control"
                            :format="'MM-dd-yyyy'"
                            placeholder="Date of birth*"
                            :value="date_of_birth"
                            v-model="date_of_birth"
                          ></datepicker> -->
                          <datepicker
                            v-model="date_of_birth"
                            @selected="birthDate"
                            placeholder="Date of birth*, M/D/Y"
                            input-class="form-control"
                            style="border: 2px solid #045C68 !important;"
                            :class="{ 'is-invalid': errors.date_of_birth }"
                            format="MM/dd/yyyy"
                            :typeable="true"
                          ></datepicker>
                          <span
                            class="text-danger"
                            v-if="errors.date_of_birth"
                            >{{ this.errors.date_of_birth[0] }}</span
                          >
                        </div>
                      </div>
                        <div class="col-md-8">
                        <div class="form-group">
                          <label for="">Address</label>
                          <textarea
                            name=""
                            class="form-control"
                            id=""
                            v-model="address"
                            cols="30"
                            placeholder="Address"
                          ></textarea>
                          <span class="text-danger" v-if="errors.address">{{
                            this.errors.address[0]
                          }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="row mb-3">
                      <div class="col-md-4">
                        <div class="form-group">
                          <label for="">City</label>
                          <input
                            type="text"
                            class="form-control"
                            v-model="city"
                            placeholder="City"
                          />
                          <span class="text-danger" v-if="errors.zip">{{
                            this.errors.zip[0]
                          }}</span>
                        </div>
                      </div>
                    
                      <div class="col-md-5">
                        <div class="form-group">
                          <label for="">State</label>
                          <input
                            type="text"
                            class="form-control"
                            v-model="state"
                            placeholder="State"
                          />
                          <span class="text-danger" v-if="errors.state">{{
                            this.errors.state[0]
                          }}</span>
                        </div>
                      </div>
                      
                      <div class="col-md-3">
                        <div class="form-group">
                          <label for="">ZIP</label>
                          <input
                            type="text"
                            class="form-control"
                            v-model="zip"
                            placeholder="ZIP"
                          />
                          <span class="text-danger" v-if="errors.zip">{{
                            this.errors.zip[0]
                          }}</span>
                        </div>
                      </div>
                    </div>

                    <div class="row mb-3">
                      <div class="col-md-6">
                        <div class="form-group">
                          <input
                            type="password"
                            class="form-control"
                            v-model="password"
                            placeholder="Password*"
                          />
                          <span class="text-danger" v-if="errors.password">{{
                            this.errors.password[0]
                          }}</span>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <input
                            type="password"
                            class="form-control"
                            v-model="confirm_password"
                            placeholder="Confirm Password*"
                          />
                          <span
                            class="text-danger"
                            v-if="errors.confirm_password"
                            >{{ this.errors.confirm_password[0] }}</span
                          >
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label  for="">How did you hear about us?</label>
                          <label class=" my-2 wrap">
                            <select v-model="know_about_us"  id="property_type" class="form-control noBorder">
                              <option value=""> --Select-- </option>
                              <option value="Facebook/ Instagram" >Facebook/ Instagram</option>
                              <option value="Google Search" >Google Search</option>
                              <option value="Doctors office" >Doctors office</option>
                              <option value="Friend/Family Member" >Friend/Family Member</option>
                              <option value="TV commercial" >TV commercial</option>
                              <option value="Physician/Nurse" >Physician/Nurse</option>
                              <option value="Digital Email" >Digital Email</option>
                              <option value="Other" >Other</option>
                              <!-- <option value="0">Other</option> -->
                            </select>
                          </label>
                          <span class="text-danger" v-if="errors.know_about_us">{{
                            this.errors.know_about_us[0]
                          }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="row mb-1">
                      <!-- /.col -->
                      <div class="mt-4 col-lg-6 col-sm-12 mb-2">
                        <button
                          @click="register"
                          type="button"
                          class="btn btn-light1 btn-block px-4"
                        >
                          Create Account
                        </button>
                      </div>
                      <div class="col-md-3 py-5">
                        <router-link class="text3-c" to="/site">
                          Login</router-link
                        >
                      </div>
                    </div>
                    <!-- /.col -->
                  </form>
                </div>
                <!-- /.login-card-body -->
              </div>
              <img
                src="@/assets/site/images/contact.webp"
                style="position: absolute; left: 100%; width: 45%; bottom: 0%"
                alt
                class="img-fluid"
              />
            </div>
          </div>
        </div>
      </section>
    </b-overlay>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";

export default {
  name: "SignupView",
  components: {
    Datepicker,
  },
  data() {
    return {
      first_name: null,
      last_name: null,
      email: null,
      password: null,
      confirm_password: null,
      errors: [],
      loader: false,
      date_of_birth: null,
      address: null,
      phone: null,
      zip: null,
      state: null,
      city: null,
      redirect_link: "",
      know_about_us: "",
    };
  },
  created() {
    this.resetdob();
    var redirectLink = localStorage.getItem("redirectLink");
    let redirect_link = JSON.parse(redirectLink);
    this.redirect_link = redirect_link;
  },
  methods: {
    register() {
      //Save or update User Details
      this.errors = [];
      if (this.phone != null) {
        if (this.phone.length >= 10) {
          this.loader = true;
          let apiUrl = process.env.VUE_APP_URL + "api/register";
          let method_type = "post";
          fetch(apiUrl, {
            method: method_type,
            headers: {
              "content-type": "application/json",
              "X-Requested-With": "XMLHttpRequest",
            },
            body: JSON.stringify({
              first_name: this.first_name,
              last_name: this.last_name,
              email: this.email,
              date_of_birth: this.date_of_birth,
              password: this.password,
              confirm_password: this.confirm_password,
              address: this.address,
              state: this.state,
              zip: this.zip,
              city: this.city,
              phone: this.phone,
              know_about_us: this.know_about_us,
            }),
          })
            .then((res) => res.json())
            .then((data) => {
              this.loader = false;
              if (data.status === true) {
                this.resetForm();
                var userData = {
                  user: data.user,
                  token: data.token,
                  // oc_login_link: data.oc_login_link,
                  status: true,
                };
                localStorage.setItem(
                  "oc_login_link",
                  JSON.stringify(data.oc_login_link)
                );
                localStorage.setItem("userData", JSON.stringify(userData));
                var sessionId = JSON.parse(localStorage.getItem("sessionId"));
                if (sessionId) {
                  this.signUpUserSession(sessionId);
                } else {
                  console.log(this.redirect_link );
                  if(this.redirect_link == "checkout"){
                    let cartUrl = this.redirect_link;
                    this.redirect_link = "";
                    localStorage.removeItem("redirectLink");
                    window.location.href = data.oc_login_link+"&redirectlink=" + cartUrl; 
                  }else{
                     window.location.href = "/user/dashboard";
                  }
                  // window.location.href = "/user/dashboard";
                }
              } else if (data.status === false) {
                this.$swal("Error", data.message, "error");
              } else {
                this.loader = false;
                this.errors = data.errors;
              }
            })
            .catch(function (err) {
              console.log("Register Data", "Error : " + err.message, "error");
            });
        } else {
          this.errors = { phone: ["The phone should be of 10 digits"] };
        }
      } else {
        this.errors = { phone: ["The phone feild is required"] };
      }
    },
    resetForm() {
      this.first_name = null;
      this.last_name = null;
      this.email = null;
      this.password = null;
      this.confirm_password = null;
      this.errors = [];
    },
    signUpUserSession(sessionId) {
      console.log("session store fn");
      this.loader = true;
      var token = localStorage.getItem("userData");
      var userdata_array = JSON.parse(token);
      var api_token = userdata_array.token;
      var fetch_url = process.env.VUE_APP_URL + "api/session/signUpSession";
      fetch(fetch_url, {
        method: "post",
        headers: {
          "content-type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
          Authorization: "Bearer " + api_token,
        },
        body: JSON.stringify({
          session_id: sessionId,
          user_id: userdata_array.user.id,
        }),
      })
        .then((res) => res.json())
        .then((data) => {
          this.loader = false;
          if (data.status === true) {
            this.loader = false;
            this.$swal("Good to Go", data.message, "success");
            localStorage.removeItem("sessionId");
            // this.$router.push('/lactation_edn');
            window.location.href = "/lactation_edn";
          } else if (data.status === false) {
            this.loader = false;
            this.$swal("Error", data.message, "error");
            localStorage.removeItem("sessionId");
            // this.$router.push('/lactation_edn');
            window.location.href = "/lactation_edn";
          } else {
            this.loader = false;
            this.errors = data.errors;
          }
        })
        .catch(function (err) {
          console.log("Fetch Error :-S", err);
        });
    },
    resetdob() {
      if (this.date_of_birth == null) {
        var d = new Date();
        var year = d.getFullYear();
        var month = d.getMonth();
        var day = d.getDate();
        // var date1 = today.getDate()+'-'+(today.getMonth()+1)+'-'+(today.getFullYear()-18);
        var date = new Date(year - 18, month, day).toISOString().substr(0, 10);
        this.date_of_birth = date;
        console.log(date);
      }
    },
    birthDate(date) {
      var edd = moment(date).format("yyyy-MM-DD");
      this.birth_date_error=null;
      var split_array=edd.split('-');
      if(split_array[0]=='Invalid date'){
        this.birth_date_error='Please select date in MM/DD/YYYY format'
      }
      this.date_of_birth = edd;
    },
  },
};
</script>
<style scoped>
textarea.form-control {
  height: 68px !important;
}
</style>